export class Filter {
  constructor(
    endPointUrl,
    filterCheckboxClass,
    filterSelectClass,
    filterPriceId,
    filterId,
    productListId,
    ordererId,
    ordererLinkClass,
    pagerProductsCountId,
    pagerId,
    pagerBottomId,
    pagerLinkClass,
    showMoreId,
    showMoreWrapperId,
    nextLinkId,
    notFoundId,
    siteBackdropId,
    selectedFilterId,
    clearSelectedClass,
    clearId,
    settingsId,
    h1Id,
    descriptionId,
    additionalDescriptionId,
    shortDescriptionId,
    lazyLoadUpdateFn
  ) {
    this.endPointUrl = endPointUrl;
    this.filterCheckboxClass = filterCheckboxClass;
    this.filterSelectClass = filterSelectClass;
    this.filterPriceId = filterPriceId;
    this.filter = document.getElementById(filterId);
    this.productList = document.getElementById(productListId);
    this.orderer = document.getElementById(ordererId);
    this.ordererLinkClass = ordererLinkClass;
    this.pagerProductsCount = document.getElementById(pagerProductsCountId);
    this.pager = document.getElementById(pagerId);
    this.pagerBottom = document.getElementById(pagerBottomId);
    this.pagerLinkClass = pagerLinkClass;
    this.showMoreId = showMoreId;
    this.showMoreWrapper = document.getElementById(showMoreWrapperId);
    this.nextLinkId = nextLinkId;
    this.notFound = document.getElementById(notFoundId);
    this.siteBackdrop = document.getElementById(siteBackdropId);
    this.siteBackdropLoader = document.querySelector(
      '#' + siteBackdropId + ' .site__backdrop-loader'
    );
    this.selectedFilter = document.getElementById(selectedFilterId);
    this.clearSelectedClass = clearSelectedClass;
    this.clearId = clearId;
    this.currentLocation = this.getCurrentLocation();
    this.filterSettingsUrl = this.getFilterSettingsUrl(settingsId);
    this.h1 = document.getElementById(h1Id);
    this.description = document.getElementById(descriptionId);
    this.additionalDescription = document.getElementById(
      additionalDescriptionId
    );
    this.shortDescription = document.getElementById(shortDescriptionId);
    this.lazyLoadUpdateFn = lazyLoadUpdateFn;

    this.listen();
  }

  async listen() {
    await this.initPriceSlider();
    this.initListeners();
  }

  redraw(
    ajaxURL,
    browserURL,
    scrollToId = null,
    appendProducts = false,
    scroll = false,
    showModal = false
  ) {
    if (this.siteBackdrop) {
      this.siteBackdrop.classList.add('site__backdrop--show');
      this.siteBackdrop.style.zIndex = 10000;
      this.siteBackdrop.style.display = 'block';
    }

    if (this.siteBackdropLoader) {
      this.siteBackdropLoader.style.display = 'flex';
    }

    this.getData(ajaxURL)
      .then((data) => {
        this.redrawProductList(data.products, appendProducts);
        this.redrawFilter(data.filter, showModal);
        this.redrawOrderer(data.orderer);
        this.redrawProductsCount(data.productsCount);
        this.redrawPager(data.pager);
        this.redrawShowMore(data.showMore, data.productCountOnNextPage);
        this.redrawSelectedFilter(data.selectedFilter);
        this.redrawH1(data.h1);
        this.redrawDescription(this.description, data.page, data.description);
        this.redrawDescription(
          this.additionalDescription,
          data.page,
          data.additionalDescription
        );
        this.redrawDescription(
          this.shortDescription,
          data.page,
          data.shortDescription
        );

        this.changeBrowserURL(browserURL);
        if (this.siteBackdrop) {
          this.siteBackdrop.classList.remove('site__backdrop--show');
          this.siteBackdrop.style.zIndex = '';
          this.siteBackdrop.style.display = 'none';
        }

        if (this.siteBackdropLoader) {
          this.siteBackdropLoader.style.display = 'none';
        }

        this.initPriceSlider();
        this.initListeners();
        this.initComponents();
        this.lazyLoadUpdate();
        this.dropdownRefresh();
        this.tooltipRefresh();
        this.mobileTooltips();
      })
      .finally(() => {
        if (scroll) {
          let target = document.getElementById('js-filter-grid-wrapper');
          if (target) {
            let targetScrollPosition = parseInt(target.offsetTop, 10) - 140;
            window.scroll(0, targetScrollPosition);
          }
        } else if (scrollToId && window.innerWidth < 992) {
          const filterModalBody = document.querySelector(
            '#filterModal .modal-body'
          );

          let target = document.getElementById(scrollToId);
          if (target && filterModalBody) {
            let targetScrollPosition = parseInt(target.offsetTop, 10) - 10;
            filterModalBody.scroll(0, targetScrollPosition);
          }
        }
      });
  }

  redrawProductList(html, append) {
    if (this.productList) {
      if (append) {
        this.productList.innerHTML = this.productList.innerHTML + html;
      } else {
        this.productList.innerHTML = html;
      }
    } else {
      console.warn(`product list with not found`);
    }

    const skeleton = document.querySelector('.js-product-filter-skeleton');
    if (skeleton) {
      skeleton.style.display = 'none';
    }
    if (this.notFound) {
      if (html === '') {
        this.notFound.classList.remove('d-none');
      } else {
        this.notFound.classList.add('d-none');
      }
    }
  }

  mobileTooltips() {
    const isMobile = window.innerWidth < 992;
    document
      .querySelectorAll(
        "[data-bs-toggle='tooltip'], [data-bss-toggle='tooltip']"
      )
      .forEach((el) => {
        console.log('Filters detected!');

        if (isMobile) {
          el.addEventListener('click', async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const { default: Tooltip } = await import(
              'bootstrap/js/dist/tooltip'
            );
            const tooltip = new Tooltip(el, {
              trigger: 'manual',
            });
            tooltip.show();

            setTimeout(() => tooltip.hide(), 4000);
          });
        }
      });
  }

  async redrawFilter(html, showModal) {
    if (this.filter) {
      this.filter.innerHTML = html;

      if (showModal && window.innerWidth < 992) {
        const modalElement = document.getElementById('filterModal');

        if (modalElement) {
          const body = document.querySelector('body');
          const modalBackdrop = document.querySelector('.modal-backdrop');

          if (modalBackdrop) {
            modalBackdrop.remove();
            body.classList.remove('modal-open');
            body.style.removeProperty('overflow');
            body.style.removeProperty('padding-right');
          }
          let { default: Modal } = await import('bootstrap/js/dist/modal');
          const modal = new Modal(modalElement, {});
          modal.show();
        }
      }
    }
  }

  redrawOrderer(html) {
    if (this.orderer) {
      this.orderer.innerHTML = html;
    }
  }

  redrawProductsCount(html) {
    if (this.pagerProductsCount) {
      this.pagerProductsCount.innerHTML = html;
    }
  }

  redrawPager(html) {
    if (this.pager) {
      this.pager.innerHTML = html;
    }

    if (this.pagerBottom) {
      this.pagerBottom.innerHTML = html;
    }
  }

  redrawShowMore(html, count) {
    if (this.showMoreWrapper) {
      this.showMoreWrapper.innerHTML = html;

      if (count > 0) {
        this.showMoreWrapper.classList.remove('d-none');
      } else {
        this.showMoreWrapper.classList.add('d-none');
      }
    }
  }

  redrawSelectedFilter(html) {
    if (this.selectedFilter) {
      this.selectedFilter.innerHTML = html;
    }
  }

  redrawH1(h1) {
    if (this.h1) {
      this.h1.innerHTML = h1;
    }
  }

  redrawDescription(element, page, description) {
    if (element) {
      if (page > 1) {
        element.innerHTML = '';
      } else {
        element.innerHTML = description;
      }
    }
  }

  getData(url) {
    return fetch(url)
      .then((data) => {
        return data.json();
      })
      .then()
      .catch((error) => {});
  }

  getURLs(href) {
    return {
      ajaxURL: this.ajaxify(href),
      browserURL: this.browserify(href),
    };
  }

  getClearURL() {
    const additionalParams = this.getAdditionalParams();

    if (additionalParams) {
      return {
        ajaxURL: this.ajaxify(this.currentLocation + '?' + additionalParams),
        browserURL: this.currentLocation + '?' + additionalParams,
      };
    }

    return {
      ajaxURL: this.ajaxify(this.currentLocation),
      browserURL: this.currentLocation,
    };
  }

  ajaxify(urlFromHref) {
    return this.endPointUrl + '?url=' + encodeURIComponent(urlFromHref);
  }

  browserify(urlFromHref) {
    return urlFromHref;
  }

  changeBrowserURL(newUrl) {
    history.pushState(null, null, newUrl);
  }

  addPriceToURLs(url, minParameterName, maxParameterName, fromValue, toValue) {
    const urlWithPrices = this.addPriceToURL(
      url,
      minParameterName,
      maxParameterName,
      fromValue,
      toValue
    );
    return {
      ajaxURL: this.ajaxify(urlWithPrices),
      browserURL: this.browserify(urlWithPrices),
    };
  }

  addPriceToURL(
    formURL,
    minParameterName,
    maxParameterName,
    fromValue,
    toValue
  ) {
    const cropped = formURL.split('?');
    let urlWithoutParams = cropped[0];
    let params = cropped[1];

    if (params) {
      params = this.removeURLFragment(params, minParameterName);
      params = this.removeURLFragment(params, maxParameterName);
      params = this.removeURLParameter(params, minParameterName);
      params = this.removeURLParameter(params, maxParameterName);
    }

    params += `&${minParameterName}=${fromValue}&${maxParameterName}=${toValue}`;
    return urlWithoutParams + (params ? '?' + params : '');
  }

  async initPriceSlider() {
    let priceSlider = document.getElementById(this.filterPriceId);

    if (priceSlider) {
      let handle = priceSlider.querySelector('.price-slider-handle');
      let min = priceSlider.querySelector('.price-slider__min span');
      let max = priceSlider.querySelector('.price-slider__max span');
      let dataValues = [min, max];

      let start = parseInt(min.getAttribute('data-selected'));
      let end = parseInt(max.getAttribute('data-selected'));

      if (!start) {
        start = parseInt(min.textContent);
      }

      if (!end) {
        end = parseInt(max.textContent);
      }
      let { create } = await import('nouislider');
      create(handle, {
        start: [
          Math.max(parseInt(min.textContent), start),
          Math.min(parseInt(max.textContent), end),
        ],
        connect: [false, true, false],
        range: {
          min: [parseInt(min.textContent)],
          max: [parseInt(max.textContent)],
        },
      });

      handle.noUiSlider.on('update', function (values, handle) {
        dataValues[handle].innerHTML = ~~values[handle];
      });

      const thisClass = this;
      handle.noUiSlider.on('set', function (values) {
        const currentURL = priceSlider.getAttribute('data-action');
        const { ajaxURL, browserURL } = thisClass.addPriceToURLs(
          currentURL,
          'priceFrom',
          'priceTo',
          Math.trunc(values[0]),
          Math.trunc(values[1])
        );
        thisClass.redraw(
          ajaxURL,
          browserURL,
          thisClass.filterPriceId,
          false,
          false,
          true
        );
      });
    }
  }

  initListeners() {
    const thisClass = this;

    this.mobileTooltips();

    const checkboxElements = document.getElementsByClassName(
      this.filterCheckboxClass
    );

    Array.from(checkboxElements).forEach(function (element) {
      element.addEventListener('change', (e) => {
        const href = e.target.getAttribute('href');
        const id = e.target.getAttribute('id');
        const { ajaxURL, browserURL } = thisClass.getURLs(href);
        thisClass.redraw(ajaxURL, browserURL, id, false, false, true);
      });
    });

    const selectElements = document.getElementsByClassName(
      this.filterSelectClass
    );
    Array.from(selectElements).forEach(function (element) {
      element.addEventListener('change', (e) => {
        const id = e.target.getAttribute('id');
        const { ajaxURL, browserURL } = thisClass.getURLs(e.target.value);
        thisClass.redraw(ajaxURL, browserURL, id, false, false, true);
      });
    });

    const showMore = document.getElementById(thisClass.showMoreId);

    if (showMore) {
      showMore.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const nextLink = document.getElementById(thisClass.nextLinkId);
        const href = nextLink.getAttribute('href');
        const { ajaxURL, browserURL } = thisClass.getURLs(href);
        thisClass.redraw(ajaxURL, browserURL, null, true);
      });
    }

    const ordererLinkElements = document.getElementsByClassName(
      this.ordererLinkClass
    );
    this.setClickListeners(ordererLinkElements);

    const pagerLinkElements = document.getElementsByClassName(
      this.pagerLinkClass
    );
    this.setClickListeners(pagerLinkElements);

    const selectedFilterElements = document.getElementsByClassName(
      this.clearSelectedClass
    );
    this.setClickListeners(selectedFilterElements);

    const clearAll = document.getElementById(thisClass.clearId);

    if (clearAll) {
      clearAll.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { ajaxURL, browserURL } = thisClass.getClearURL();
        thisClass.redraw(ajaxURL, browserURL);
      });
    }
  }

  async initComponents() {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll(
        "[data-bs-toggle='tooltip'], [data-bss-toggle='tooltip']"
      )
    );
    if (tooltipTriggerList.length) {
      let { default: Tooltip } = await import('bootstrap/js/dist/tooltip');
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
      });
    }
  }

  removeURLFragment(url, parameterName) {
    const regular = new RegExp('(/' + parameterName + '=.+/&)', 'g');
    url = url.replace(regular, '');
    return url;
  }

  removeURLParameter(url, parameterName) {
    const parametersArray = url.split('&');

    for (let i = parametersArray.length - 1; i >= 0; i -= 1) {
      const param = parametersArray[i].split('=')[0];
      if (param === parameterName) {
        parametersArray.splice(i, 1);
      }
    }

    return parametersArray.join('&');
  }

  getCurrentLocation() {
    const href = window.location.href;

    if (href) {
      const splice = href.split('?');
      if (splice) {
        return splice[0];
      }
    }

    console.error('Could not get current location URL.');
  }

  getAdditionalParams() {
    let uri = decodeURI(this.filterSettingsUrl);

    let result = new URLSearchParams();

    uri.split('&').forEach((item) => {
      if (item.startsWith('filterSource')) {
        const itemSplit = item.split('=');
        const property = itemSplit[0];
        const value = itemSplit[1];

        if (
          property !== 'filterSource[type]' &&
          property !== 'filterSource[uuid]'
        ) {
          const matches = property.match(/\[(.*?)\]/);
          result.append(matches[1], value);
        }
      }
    });

    return result.toString();
  }

  getFilterSettingsUrl(elementId) {
    const el = document.getElementById(elementId);

    if (el) {
      const json = JSON.parse(el.innerHTML);
      if (json) {
        return json.filterSettings;
      }
    }

    return '';
  }

  lazyLoadUpdate() {
    if (this.lazyLoadUpdateFn) {
      this.lazyLoadUpdateFn();
    }
  }

  setClickListeners(elements) {
    const thisClass = this;
    Array.from(elements).forEach(function (element) {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const href = element.getAttribute('href');
        const { ajaxURL, browserURL } = thisClass.getURLs(href);
        thisClass.redraw(ajaxURL, browserURL, null, false, true);
        thisClass.lazyLoadUpdate && thisClass.lazyLoadUpdate();
      });
    });
  }

  async dropdownRefresh() {
    const { dropdownInit } = await import('./common/dropdown');
    dropdownInit();
  }

  async tooltipRefresh() {
    let { tooltipInit } = await import('./common/tooltip');
    tooltipInit();
  }
}
